import { useEffect, useState } from 'react'
import { Popover, Field } from '../ds/index.js'

// Popover for linking an existing record. `candidates` are records with `.id`;
// `existingIds` are already-linked ids to exclude; `labelOf(record)` is the display
// string (also the search key). onPick(record) links; onClose() dismisses.
// Renders inside a `.cn-popover-wrap` (see AssociationsColumn) via kit Popover —
// `open` defaults true since callers historically only mount this while open.
export default function AssociationPicker({ candidates = [], existingIds = [], labelOf = (r) => r.id, open = true, onPick, onClose }) {
  const [q, setQ] = useState('')

  // Re-seed the search draft each time the picker opens — it stays mounted
  // (Popover open/close, not conditional mount) so local state would
  // otherwise persist across reopen, unlike the original conditional-mount
  // behavior which always started with an empty search.
  useEffect(() => {
    if (open) setQ('')
  }, [open])

  const excluded = new Set(existingIds)
  const query = q.trim().toLowerCase()
  const list = candidates
    .filter((c) => !excluded.has(c.id))
    .filter((c) => !query || labelOf(c).toLowerCase().includes(query))
    .slice(0, 50)
  return (
    <Popover open={open} onClose={onClose} align="right">
      <Field autoFocus placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} style={{ marginBottom: 6 }} />
      <div style={{ maxHeight: 200, overflowY: 'auto' }}>
        {list.map((c) => (
          <button key={c.id} type="button" onClick={() => onPick(c)}
            style={{ display: 'block', width: '100%', textAlign: 'left', background: 'none', border: 'none',
              cursor: 'pointer', padding: '6px 8px', fontSize: 13, color: 'var(--color-white)', borderRadius: 'var(--radius-sm)' }}>
            {labelOf(c)}
          </button>
        ))}
        {list.length === 0 && <div style={{ padding: '6px 8px', fontSize: 12, color: 'var(--color-muted)' }}>No matches.</div>}
      </div>
    </Popover>
  )
}
